import React from 'react';
import { withStyles } from '@material-ui/core/styles';

var InvPlusIconComp = function InvPlusIconComp(props) {
  var classes = props.classes,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 34.78 34.78' : _props$viewBox,
      _props$width = props.width,
      width = _props$width === void 0 ? '24px' : _props$width,
      _props$height = props.height,
      height = _props$height === void 0 ? '24px' : _props$height;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewBox,
      width: width,
      height: height
    },
    /*#__PURE__*/
    React.createElement("title", null, "Asset 2"),
    /*#__PURE__*/
    React.createElement("g", {
      id: "Layer_2",
      "data-name": "Layer 2"
    },
    /*#__PURE__*/
    React.createElement("g", {
      id: "Layer_1-2",
      "data-name": "Layer 1"
    },
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls1,
      d: "M29.69,5.09a17.39,17.39,0,1,1-24.6,0,17.4,17.4,0,0,1,24.6,0"
    }),
    /*#__PURE__*/
    React.createElement("path", {
      className: classes.cls2,
      d: "M18.49,8.62l1.28,5.55a1.15,1.15,0,0,0,.85.84l5.54,1.29a1.12,1.12,0,0,1,0,2.19l-5.54,1.28a1.15,1.15,0,0,0-.85.85l-1.28,5.54a1.12,1.12,0,0,1-2.19,0L15,20.62a1.15,1.15,0,0,0-.84-.85L8.62,18.49a1.12,1.12,0,0,1,0-2.19L14.17,15a1.16,1.16,0,0,0,.84-.84L16.3,8.62a1.12,1.12,0,0,1,2.19,0"
    }))))
  );
};

var styles = function styles(theme) {
  return {
    cls1: {
      fill: theme.palette.product.inventoryPlus
    },
    cls2: {
      fill: theme.palette.common.white,
      fillRule: 'evenodd'
    }
  };
};

export var InvPlusIcon = withStyles(styles)(InvPlusIconComp);